// Close the topbar <details> dropdown when the user clicks outside of it
// or presses Escape. Native <details> only toggles via its <summary>.

document.addEventListener("click", (event) => {
  document.querySelectorAll("details.trunfo-topbar__menu[open]").forEach((node) => {
    if (!node.contains(event.target)) {
      node.removeAttribute("open");
    }
  });
});

document.addEventListener("keydown", (event) => {
  if (event.key !== "Escape") return;
  document
    .querySelectorAll("details.trunfo-topbar__menu[open]")
    .forEach((node) => node.removeAttribute("open"));
});
